import { render, staticRenderFns } from "./list_collect.vue?vue&type=template&id=6a0d408c&scoped=true&"
import script from "./list_collect.vue?vue&type=script&lang=js&"
export * from "./list_collect.vue?vue&type=script&lang=js&"
import style0 from "./list_collect.vue?vue&type=style&index=0&id=6a0d408c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d408c",
  null
  
)

export default component.exports